import type {ComponentProps, ReactNode} from 'react';
import {ChevronDown} from 'lucide-react';
import {Badge, Button} from '@kroll-resolver-crisp/ui-components-react';
import {ACTIVE_FILTER_TRIGGER} from '@/lib/filterTrigger';
import {FILTER_BAR_COMPACT_HIDDEN, FILTER_BAR_COMPACT_LABEL} from '@/lib/filterBar';
import {cn} from '@/lib/utils';

// A toolbar chip: an outline button whose active count sits in a small badge before the chevron.
// Every filter and sort menu trigger in the toolbars renders this, so they stay one weight.
export function FilterChip({
  icon,
  label,
  count,
  active = false,
  className,
  ...props
}: Omit<ComponentProps<typeof Button>, 'variant' | 'size'> & {
  readonly icon?: ReactNode;
  readonly label: ReactNode;
  readonly count?: number;
  // Marks the chip as holding a selection (the ACTIVE_FILTER_TRIGGER look).
  readonly active?: boolean;
}) {
  return (
    <Button
      variant="outline"
      size="sm"
      className={cn('shrink-0', active && ACTIVE_FILTER_TRIGGER, className)}
      {...props}>
      {icon}
      <span className={cn('flex items-center gap-1.5', FILTER_BAR_COMPACT_LABEL)}>{label}</span>
      {count ? <Badge className="h-4 min-w-4 px-1">{count}</Badge> : null}
      <ChevronDown className={cn('text-muted-foreground', FILTER_BAR_COMPACT_HIDDEN)} />
    </Button>
  );
}
